import type { SearchSchemaInput } from '@tanstack/react-router';
import { parseEnum } from '@/shared/lib/listSearch';

/**
 * Which tab of a player's page is open.
 *
 * In the URL for the same reason onboarding's is: a link to "Lucas's contract"
 * should open there, and a refresh should not throw the user back to Personal.
 *
 * A search param rather than six child routes. `modules/settings` uses real
 * routes and is right to, because each settings tab is a separate page with its
 * own data. These six are views of **one** player — the detail query feeds five
 * of them, and the sixth loads its own record but still belongs to the same
 * player. Six route definitions differing only in which slice they render would
 * be six places to keep in step.
 */
export const PLAYER_TABS = [
  'personal',
  'contract',
  'career',
  'actions',
  'edit',
  'offboarding',
] as const;

export type PlayerTab = (typeof PLAYER_TABS)[number];

export interface PlayerDetailSearch {
  tab: PlayerTab;
}

export function validatePlayerDetailSearch(
  search: Partial<Record<keyof PlayerDetailSearch, unknown>> & SearchSchemaInput,
): PlayerDetailSearch {
  return {
    // An unknown tab falls back rather than rendering nothing — a hand-edited
    // or stale link should still show a usable screen.
    tab: parseEnum(search.tab, PLAYER_TABS) ?? 'personal',
  };
}
